/// <amd-module name="Test/Analytics/TestAnalyticInsightsReportView/Actions/TestInsightsReportViewActions" />
import { ITestResultTreeData } from "Test/common-util/Contracts/ViewContracts";
import { Action } from "VSS/Reflux/Action";

export class TestInsightsReportViewActions {
    public setTestResultTreeData = new Action<ITestResultTreeData>();
    public closeDetailsPanel = new Action<void>();
    public onError = new Action<Error>();
}
